import { Inject, Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { TableService } from './table.service';

@Injectable({
  providedIn: 'root',
})
export class TableExtendedService extends TableService<any> {
  constructor(
    @Inject(HttpClient) http,
    router: Router,
    activatedRoute: ActivatedRoute
  ) {
    super(http, router, activatedRoute);
  }
}
